<template>
  <div class="masterdata-sidebar">
    <div v-if="currentTab === 'dokumen'">
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'default' }"
        @click="changeContent('default')">
        Default
      </div>
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'akta' }" @click="changeContent('akta')">
        Akta
      </div>
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'komersial' }"
        @click="changeContent('komersial')">
        Komersial
      </div>
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'perizinan' }"
        @click="changeContent('perizinan')">
        Perizinan
      </div>
    </div>

    <div v-if="currentTab === 'badan_usaha'">
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'nasional_bu' }"
        @click="changeContent('nasional_bu')">
        Nasional
      </div>
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'internasional_bu' }"
        @click="changeContent('internasional_bu')">
        Internasional
      </div>
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'khusus_bu' }"
        @click="changeContent('khusus_bu')">
        Khusus
      </div>
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'internal_memo_bu' }"
        @click="changeContent('internal_memo_bu')">
        Internal Memo
      </div>
    </div>

    <div v-if="currentTab === 'perorangan'">
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'nasional' }"
        @click="changeContent('nasional')">
        Nasional
      </div>
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'internasional' }"
        @click="changeContent('internasional')">
        Internasional
      </div>
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'khusus' }"
        @click="changeContent('khusus')">
        Khusus
      </div>
      <div class="masterdata-sidebar__menus" :class="{ active: selectedOpt === 'internal_memo' }"
        @click="changeContent('internal_memo')">
        Internal Memo
      </div>
    </div>
  </div>
</template>
  
<script>
export default {

  props: { 'currentTab': String, },

  data() {
    return {
      selectedOpt: 'default',
    }
  },
  methods: {
    changeContent(content) {
      this.selectedOpt = content;
      this.$emit('content-change', content);
    },
  },
  watch: {
    currentTab(newTab) {
      if (newTab === 'dokumen') {
        this.selectedOpt = 'default';
        this.changeContent('default');
      }
      else if (newTab === 'badan_usaha') {
        this.selectedOpt = 'nasional';
        this.changeContent('nasional');
      }
      else if (newTab === 'perorangan') {
        this.selectedOpt = 'nasional';
        this.changeContent('nasional');
      }
    },
  },
}
</script>
  